import { PropsWithoutRef, forwardRef, Ref, FunctionComponent } from 'react';

import { useI18n } from '../../../../hooks';
import FormField from '../../../FormField';
import { ForwardProps } from '../../../../types';

import Time from './Time';
import NumberUnit from './NumberUnit';
import DurationInputProps, { Format } from './DurationInput.types';

const DurationInput: FunctionComponent<DurationInputProps & ForwardProps> = forwardRef(
  (props: PropsWithoutRef<DurationInputProps>, ref: Ref<HTMLFieldSetElement>) => {
    const {
      id,
      label,
      labelHidden,
      required,
      status,
      disabled,
      onChange,
      format = Format.Seconds,
      onSelect,
      ...restProps
    } = props;
    const t = useI18n();

    const Comp =
      format === Format.Formatted ? (
        <Time {...{ status, disabled, onChange }} {...restProps} />
      ) : (
        <NumberUnit {...{ format, status, disabled, onChange, onSelect }} {...restProps} />
      );

    return label ? (
      <FormField
        as='fieldset'
        labelAs='legend'
        info={format === Format.Formatted && t('time_format_info')}
        status={status}
        {...{ label, labelHidden, id, required, disabled, ref }}
      >
        {Comp}
      </FormField>
    ) : (
      Comp
    );
  }
);

export default DurationInput;
